import { EFontFamily } from '../PDFTextmarkContainer';

interface IProps {
  fontFamily: EFontFamily;
  onFontFamilyChange: (value: EFontFamily) => void;
}

export const PDFTextmarkFontPicker = (props: IProps) => {
  const { fontFamily, onFontFamilyChange } = props;

  const fonts = Object.values(EFontFamily);

  return (
    <select
      style={{ height: '1.75rem' }}
      value={fontFamily}
      onChange={(e) => onFontFamilyChange?.(e.target.value as EFontFamily)}
    >
      {fonts.map((font) => (
        <option value={font}>{font}</option>
      ))}
    </select>
  );
};
